import { gql } from '@apollo/client';

export const INTEGRATION_QUERY = 'Integration';

export const GET_INTEGRATION = gql`
    query ${INTEGRATION_QUERY}($integrationId: uuid!){
        integrations_by_pk(id: $integrationId) {
            id
            playbooks {
                id
                pipelineVariables: pipeline_variables {
                    id
                    name
                }
                revision
            }
        }
    }
`;
